
import { Component, Mixins, Prop } from 'vue-property-decorator';
import Chart from 'chart.js';
import { Doughnut, mixins } from 'vue-chartjs';

@Component
export default class Chart1 extends Mixins(Doughnut) {
  @Prop({ required: true })
  private backgroundColor!: string[];

  @Prop({ required: true })
  private fillStyle!: string;

  /** 予定数 */
  @Prop({ required: true, default: 0 })
  private scheduleNumber!: number;

  /** 実績数 */
  @Prop({ required: true, default: 0 })
  private achievementNumber!: number;

  /** 余り */
  private surplusNumber: number = this.scheduleNumber - this.achievementNumber;

  private data: Chart.ChartData = {
    datasets: [
      {
        label: 'Pattern2',
        type: 'doughnut',
        data: [this.achievementNumber, this.surplusNumber],
        backgroundColor: this.backgroundColor,
        borderColor: 'transparent',
        datalabels: {
          display: false,
        },
      },
    ],
  };

  private options: Chart.ChartOptions = {
    tooltips: {
      enabled: false,
    },
    // ドーナツの細さ、円中心から何％カットするかを指定する
    cutoutPercentage: 88,
    // 凡例の削除
    legend: {
      display: false,
    },
  };

  private mounted() {
    const displayNumber = this.achievementNumber;
    const fillStyle = this.fillStyle;
    // ドーナツの中心にテキストを表示
    this.addPlugin({
      afterDraw(chart: any, go: any) {
        const ctx = chart.ctx;

        chart.data.datasets.forEach((dataset: any, i: any) => {
          let dataSum = 0;
          dataset.data.forEach((element: any) => {
            dataSum += element;
          });
          const meta = chart.getDatasetMeta(i);
          if (!meta.hidden) {
            meta.data.forEach((element: any, index: any) => {
              // フォントの設定
              const fontSize = 28;
              const fontStyle = 'normal';
              const fontFamily = '游ゴシック';
              ctx.fillStyle = fillStyle;
              ctx.font = Chart.helpers.fontString(
                fontSize,
                fontStyle,
                fontFamily
              );

              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              // ツールチップに変更内容を表示
              ctx.fillText(displayNumber, chart.width / 2, chart.height / 2);
            });
          }
        });
      },
    });
    // グラフを描画
    this.renderChart(this.data, this.options);
  }
}
